export default __webpack_public_path__ + "static/media/clipboard.a3d429ea.svg";